/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { Container } from "@mui/material";
import NoDataFound from "../../shared/components/noDataFoundBanner";
import { usePropertyReportContext } from "../../contexts/PropertyReportContext";
import { useParams } from "react-router-dom";
import Loader from "../../shared/components/loader/linearProgress";
import DocReport from "./components/docReport";

const PropertyReport = () => {
  const { pId, reportId, isDocReport } = useParams();
  const { propertyReportId, loading, reports } = usePropertyReportContext();
  const [selectedReport, setSelectedReport] = useState<any | null>();
  const [isEmbeddable, setIsEmbeddable] = useState<boolean | null>(null);
  const isDocReportBool =
    typeof reportId === "string" && reportId.includes("doc");

  useEffect(() => {
    if (isDocReportBool) {
      const reportSelected = reports?.find(
        (report: any) => report.reportSourceId === reportId,
      );
      setSelectedReport(reportSelected);
    } else {
      const reportSelected = reports?.find(
        (report: any) => report.id === reportId,
      );
      setSelectedReport(reportSelected);
    }
  }, [pId, reportId, reports, isDocReport]);

  useEffect(() => {
    document.body.style.margin = "0";
    document.documentElement.style.height = "100%";
    document.body.style.height = "100%";
  }, []);

  const handleIframeLoad = () => {
    setIsEmbeddable(true);
  };

  const handleIframeError = () => {
    setIsEmbeddable(false);
  };

  return (
    <Container className="dashboardContainerInner">
      {loading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <>
          {isDocReportBool ? (
            pId &&
            reportId && (
              <>
                <DocReport propertyId={pId} reportSourceId={reportId} />
              </>
            )
          ) : selectedReport?.reportDataLink ? (
            isEmbeddable === false ? (
              <NoDataFound />
            ) : (
              <iframe
                src={selectedReport?.reportDataLink}
                width="100%"
                height="1080"
                style={{ border: "none" }}
                loading="eager"
                title="Billing Information"
                onLoad={handleIframeLoad}
                onError={handleIframeError}
              />
            )
          ) : (
            <NoDataFound />
          )}
        </>
      )}
    </Container>
  );
};

export default PropertyReport;
